import { render } from "./mail_forward.svg.vue?vue&type=template&id=fb72c0aa"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__